import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid'

export function Pagination({page, setPage, itemsPerPage, itemsTotal}) {

    const pagesCount = Math.ceil(itemsTotal / itemsPerPage);

    const previousPage = () => {
        setPage(Math.max(page - 1, 1))
    }

    const nextPage = () => {
        setPage(Math.min(page + 1, pagesCount))
    }

    return (
        <div className="sticky z-20 bottom-0 bg-white px-4 py-3 flex items-center justify-between border-t border-r border-l border-gray-200 sm:px-6">
            <div className="flex-1 flex justify-between sm:hidden">
                <button
                    onClick={previousPage}
                    className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                >
                    Zurück
                </button>
                <button
                    onClick={nextPage}
                    className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                >
                    Vor
                </button>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                    <p className="text-sm text-gray-700">
                        Zeige <span className="font-medium">{(Math.min(1, itemsTotal)) + (itemsPerPage * (page-1))}</span> bis <span className="font-medium">{Math.min(itemsPerPage + (itemsPerPage * (page-1)), itemsTotal)}</span> von{' '}
                        <span className="font-medium">{itemsTotal}</span> Angeboten
                    </p>
                </div>
                <div>
                    <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                        <button
                            onClick={previousPage}
                            className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                        >
                            <span className="sr-only">Previous</span>
                            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                        {[...Array(pagesCount).keys()].map(x => x+1).map((pageNumber) => (
                            <button
                                aria-current="page"
                                key={pageNumber}
                                className={pageNumber === page ?
                                    'z-10 bg-red-50 border-red-500 text-red-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium' :
                                    'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium'}
                                onClick={(e) => setPage(pageNumber)}
                            >
                                {pageNumber}
                            </button>
                        ))}
                        <button
                            onClick={nextPage}
                            className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                        >
                            <span className="sr-only">Next</span>
                            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </nav>
                </div>
            </div>
        </div>
    )
}
